import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  syncOptions: {
    id: 'jJywO5',
    defaultMessage: 'Sync Options',
    description: 'Button text for sync options dropdown item',
  },
  syncDetails: {
    id: 'FTdYAl',
    defaultMessage: 'Sync Details',
    description: 'Button text for sync details dropdown item',
  },
});
